<svg viewBox="0 0 41 76" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<g clip-path="url(#clip0_3357_3064)">
		<path
			d="M8.15283 69.7175C11.0994 65.9798 16.5217 65.3381 20.2594 68.2846C17.3129 72.0223 11.8905 72.664 8.15283 69.7175Z"
			fill="white"
		/>
		<path
			d="M6.73608 66.2156C3.37076 62.8502 3.37076 57.3902 6.73609 54.0249C10.1014 57.3902 10.1014 62.8502 6.73608 66.2156Z"
			fill="white"
		/>
		<path
			d="M15.502 59.2043C11.5502 56.5518 10.4962 51.1943 13.1486 47.2425C17.1004 49.895 18.1544 55.2525 15.502 59.2043Z"
			fill="white"
		/>
		<path
			d="M23.8015 52.1055C19.3743 50.3585 17.2001 45.3498 18.9471 40.9226C23.3743 42.6696 25.5485 47.6783 23.8015 52.1055Z"
			fill="white"
		/>
		<path
			d="M28.9521 40.2688C24.1927 40.2688 20.3318 36.4078 20.3318 31.6484C25.0912 31.6484 28.9521 35.5093 28.9521 40.2688Z"
			fill="white"
		/>
		<path
			d="M28.8105 27.2311C24.4565 29.1532 19.3651 27.1805 17.443 22.8265C21.797 20.9043 26.8884 22.8771 28.8105 27.2311Z"
			fill="white"
		/>
		<path
			d="M24.5867 16.0878C20.9703 19.1819 15.5265 18.7583 12.4323 15.1419C16.0487 12.0477 21.4925 12.4714 24.5867 16.0878Z"
			fill="white"
		/>
		<path
			d="M18.9648 61.8977C21.5959 57.9316 26.9477 56.8486 30.9137 59.4797C28.2827 63.4457 22.9309 64.5287 18.9648 61.8977Z"
			fill="white"
		/>
		<path
			d="M26.6763 52.6461C27.6938 47.9967 32.291 45.0505 36.9403 46.068C35.9228 50.7174 31.3257 53.6637 26.6763 52.6461Z"
			fill="white"
		/>
		<path
			d="M31.4971 40.1289C30.917 35.405 34.2787 31.1023 39.0026 30.5222C39.5827 35.2462 36.221 39.5489 31.4971 40.1289Z"
			fill="white"
		/>
		<path
			d="M31.927 26.1779C29.5473 22.0561 30.9605 16.7819 35.0823 14.4022C37.462 18.524 36.0488 23.7981 31.927 26.1779Z"
			fill="white"
		/>
		<path
			d="M27.0728 14.7237C23.5358 11.539 23.25 6.08629 26.4347 2.54934C29.9717 5.73402 30.2574 11.1868 27.0728 14.7237Z"
			fill="white"
		/>
		<path
			d="M20.8701 9.56737C16.1235 9.91665 11.9896 6.34944 11.6403 1.60285C16.3869 1.25357 20.5208 4.82077 20.8701 9.56737Z"
			fill="white"
		/>
	</g>
	<defs>
		<clipPath id="clip0_3357_3064">
			<rect
				width="39.4125"
				height="74.0841"
				fill="white"
				transform="translate(0.640625 0.970215)"
			/>
		</clipPath>
	</defs>
</svg>
